import React from 'react'

const editable = ['product-', 'offer-banner', 'html', 'blog-posts']

export function HomeSection({ id, onEdit, custom, lang = 'es', edit = true }) {
  const isCatalog = custom && custom.type
  const { title = {} } = custom || {}
  const hiddenClass = custom.hidden ? 'hidden' : ''
  const editClass =
    (editable.some((t) => id?.includes(t)) || isCatalog) && edit
      ? 'display-edit'
      : ''

  const className = `home-section ${editClass} ${hiddenClass}`

  function onClick(e) {
    const isDiv = e.target instanceof HTMLDivElement
    if (isDiv && onEdit) onEdit(id)
  }

  const sectionLangs = custom.for_langs?.length ? (
    <b style={{ fontSize: 12, fontStyle: 'italic', margin: '0 10px' }}>
      {custom.for_langs.join(', ').toUpperCase()}
    </b>
  ) : null

  if (isCatalog) {
    return (
      <div onClick={onClick} className={className}>
        {id} {title && ` - Title: ${title[lang]}`}{' '}
        {custom.query?.groups && `- Products: ${custom.query.groups.length}`}
        {sectionLangs}
      </div>
    )
  }

  return (
    <div onClick={onClick} className={`${className}`}>
      {id}
      {sectionLangs}
    </div>
  )
}
